import React, { useState, useEffect } from 'react';
import {
  Users,
  Clock,
  Activity,
  BarChart3,
  Filter,
  Download,
  RefreshCw
} from 'lucide-react';
import { useToast } from '../../common/Toast';
import API_CONFIG from '../../../config/api';
import PageBreadcrumb from '../../common/PageBreadcrumb';
import PageHeader from '../../common/PageHeader';

const ResourceUtilizationReports = () => {
  const { success, error: showError } = useToast();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState({
    totalResources: 0,
    allocatedResources: 0,
    availableResources: 0,
    utilizationRate: 0
  });

  useEffect(() => {
    loadReportData();
  }, []);

  const loadReportData = async () => {
    setLoading(true);
    try {
      // TODO: Implement API call when backend is ready
      setReportData({
        totalResources: 50,
        allocatedResources: 35,
        availableResources: 15,
        utilizationRate: 70
      });
    } catch (err) {
      console.error('Error loading resource utilization report data:', err);
      showError('Error loading resource utilization report data.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageBreadcrumb />
      <PageHeader
        title="Resource Utilization Reports"
        description="Team allocation, time tracking, and resource capacity analysis"
      />
      <div className="page-container">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div className="spinner"></div>
            <p>Loading resource utilization reports...</p>
          </div>
        ) : (
          <div style={{ padding: '20px' }}>
            <div className="grid-modern-3" style={{ marginBottom: '24px' }}>
              <div className="asset-landing-card">
                <div style={{ padding: '24px' }}>
                  <div className="d-flex align-items-center mb-3">
                    <Users size={24} color="var(--gold-primary)" />
                    <h4 style={{ marginLeft: '12px', margin: 0 }}>Resource Utilization</h4>
                  </div>
                  <p style={{ color: '#6b7280', margin: 0 }}>
                    Resource utilization reports are coming soon. This section will display team allocation, time tracking, and resource capacity analysis.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ResourceUtilizationReports;